import React, { useContext } from 'react';
import ShareableLinksEmpty from '../ShareableLinksEmpty';
import ShareableLinksMobile from '../ShareableLinksMobile';
import ShareableLinksTable from '../ShareableLinksTable';
import useMatchMedia from 'hooks/useMatchMedia';
import { DataRoomShareableLink } from 'models/ShareableLink';
import EditShareableLinkContext from 'router/subrouters/DataRoom/providers/EditShareableLink/EditShareableLink.context';

type ShareableLinkContentProps = {
  isLoading: boolean;
  isEmpty: boolean;
  totalPages: number;
  shareableLinks: DataRoomShareableLink[];
  showVisits?: boolean;
  updateShareableLink: (shareableLink: DataRoomShareableLink) => void;
};

const ShareableLinkContent: React.FC<ShareableLinkContentProps> = (props) => {
  const {
    isLoading,
    isEmpty,
    totalPages,
    shareableLinks,
    showVisits = false,
    updateShareableLink,
  } = props;

  const { openEditShareableLink } = useContext(EditShareableLinkContext);

  const isPhablet = useMatchMedia('isPhablet');

  return (
    <>
      {!isLoading && isEmpty ? (
        <ShareableLinksEmpty />
      ) : isPhablet ? (
        <ShareableLinksMobile
          isLoading={isLoading}
          totalPages={totalPages}
          shareableLinks={shareableLinks}
          showVisits={showVisits}
          updateShareableLink={updateShareableLink}
          onRowClick={openEditShareableLink}
        />
      ) : (
        <ShareableLinksTable
          isLoading={isLoading}
          totalPages={totalPages}
          shareableLinks={shareableLinks}
          showVisits={showVisits}
          updateShareableLink={updateShareableLink}
          onRowClick={openEditShareableLink}
        />
      )}
    </>
  );
};

export default ShareableLinkContent;
